<template>
    <div>
        <!-- Bottone fisso in basso a destra -->
        <Button 
            
            @click="openModal" 
            class="ai-assistant-btn"
            severity="info"
            rounded
            size="large"
            aria-label="AI Assistant"
        >
            <img src="/img-appalto/ai-assistant-outline.svg" />
        </Button>

        <!-- Modale chat -->
        <Dialog 
            v-model:visible="visible" 
            modal 
            :header="'AI Assistant'" 
            :style="{ width: '60vw', maxHeight: '90vh', minWidth: '800px' }"
            :dismissableMask="true"
            pt:root:class="ai-assistant-modal"
        >
            <template #header>
                <div class="flex flex-col justify-between w-full">
                    <div class="flex justify-between items-center">
                        <h5 class="m-0">{{ $root.trans.assistente_ai }}</h5>
                        <i 
                            class="pi pi-times cursor-pointer !text-[13px]" 
                            @click="visible = false"
                        ></i>
                    </div>
                    <h3 class="pt-[20px] text-[31px]">Ciao {{ nomeUtente }}</h3>
                    <p class="text-[16px]">Come posso aiutarti a procedere con questo ticket?</p>
                </div>
            </template>

            <!-- Area messaggi -->
            <div class="chat-messages" ref="chatMessages" v-if="messages.length > 0">
                <div 
                    v-for="(message, index) in messages" 
                    :key="index"
                    :class="['message', message.role === 'user' ? 'message-user' : 'message-assistant']"
                >
                    <div class="message-header">
                        <i :class="message.role === 'user' ? 'pi pi-user' : 'pi pi-sparkles'"></i>
                        <strong>{{ message.role === 'user' ? 'Tu' : selectedModelLabel }}</strong>
                    </div>
                    <div class="message-content" v-html="formatMessage(message.content)"></div>
                </div>

                <!-- Loading indicator -->
                <div v-if="loading" class="message message-assistant">
                    <div class="message-header">
                        <i class="pi pi-sparkles"></i>
                        <strong>{{ selectedModelLabel }}</strong>
                    </div>
                    <div class="message-content">
                        <i class="pi pi-spin pi-spinner"></i> {{ $root.trans.sto_pensando }}
                    </div>
                </div>
            </div>

            <!-- Input area -->
            <template #footer>
                <div class="chat-input-container grow">
                    <div class="flex gap-3">
                        <!-- Textarea (3/4) -->
                        <div class="w-full">
                            <Textarea 
                                v-model="inputMessage" 
                                :autoResize="false"
                                rows="10"
                                :placeholder="$root.trans.scrivi_messaggio"
                                class="w-full"
                                @keydown.ctrl.enter="sendMessage"
                                @keydown.meta.enter="sendMessage"
                            />
                        </div>
                        
                        <!-- Colonna allegati (1/4) - contiene sia allegati esistenti che upload -->
                    </div>
                    <div class="flex justify-between gap-[40px]">
                        <div class="flex-[1] flex flex-col gap-3">
                            <!-- Allegati disponibili per selezione -->
                            <div v-if="allegati && allegati.length > 0" class="allegati-selection-section flex-1">
                                <div class="allegati-selection-header">
                                    <i class="pi pi-paperclip"></i>
                                    <strong>Allegati</strong>
                                    <span v-if="selectedAllegati.length > 0" class="selected-count">
                                        ({{ selectedAllegati.length }})
                                    </span>
                                </div>
                                <div class="allegati-selection-list">
                                    <div v-for="allegato in allegati" :key="allegato.id" class="allegato-checkbox-item">
                                        <input 
                                            type="checkbox" 
                                            :id="'allegato-' + allegato.id"
                                            v-model="selectedAllegati"
                                            :value="allegato"
                                            class="allegato-checkbox"
                                        />
                                        <label :for="'allegato-' + allegato.id" class="allegato-label">
                                            <i class="pi pi-file"></i>
                                            <span>{{ allegato.nome }}</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            
                            <!-- Box upload nuovi file -->
                            <div class="allegati-selection-section flex-1">
                                <div class="upload-area">
                                    <input 
                                        type="file" 
                                        ref="fileInput"
                                        @change="handleFileUpload"
                                        multiple
                                        accept="image/*,.pdf,.doc,.docx,.txt,.log,.json,.xml,.csv"
                                        class="hidden"
                                    />
                                    <Button 
                                        icon="pi pi-plus" 
                                        label="Allega file"
                                        @click="$refs.fileInput.click()"
                                        size="small"
                                        outlined
                                        class="w-full mb-2 ai-allegati-button"
                                    />
                                    <div v-if="uploadedFiles.length > 0" class="uploaded-files-list flex">
                                        <div class="font-bold w-[15%]">
                                            Allegati:
                                        </div>
                                        <div class="flex-1">
                                            <div v-for="(file, index) in uploadedFiles" :key="index" class="uploaded-file-item">
                                                <i class="pi pi-times cursor-pointer" @click="removeUploadedFile(index)"></i>
                                                <span>{{ file.name }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="flex-[1]">
                            <Select 
                                v-model="selectedModel" 
                                :options="ai_models" 
                                optionLabel="label" 
                                optionValue="value"
                                placeholder="Seleziona modello AI"
                                class="w-full"
                            />
                        </div>
                    </div>
                    <div class="flex justify-between items-center mt-2">
                        <div class="flex gap-2 w-full">
                            <Button 
                                label="Invia" 
                                icon="pi pi-send" 
                                @click="sendMessage"
                                :disabled="!inputMessage.trim() || loading"
                                class="!w-full text-white !bg-[#2C817C] !border-0"
                            />
                        </div>
                    </div>
                </div>
            </template>
        </Dialog>
    </div>
</template>

<style scoped>
    br{
        display:none;

    }
.ai-assistant-btn {
    position: fixed;
    bottom: 90px;
    right: 0px;
    width: 44px!important;
    height: 44px!important;
    border-radius:100%!important;
    z-index: 1000;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    background: radial-gradient(99.88% 258.27% at 0% 3%, #FA7508 0%, #FF007B 48.15%, #0900FF 100%) /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */;
    padding:0!important;

}

.ai-assistant-btn:hover {
    transform: scale(1.05);
    transition: transform 0.2s;
    background: radial-gradient(99.88% 258.27% at 0% 3%, #FA7508 0%, #FF007B 48.15%, #0900FF 100%)!important;

    /*background-color: rgb(5, 70, 105)!important;*/
}

.chat-messages {
    max-height: 500px;
    overflow-y: auto;
    padding: 1rem;
    background-color: #f8f9fa;
    border-radius: 8px;
    margin-bottom: 1rem;
}

.message {
    margin-bottom: 1rem;
    padding: 0.75rem;
    border-radius: 8px;
    max-width: 85%;
}

.message-user {
    background-color: #e3f2fd;
    margin-left: auto;
    border-bottom-right-radius: 4px;
}

.message-assistant {
    background-color: #ffffff;
    border: 1px solid #e0e0e0;
    border-bottom-left-radius: 4px;
}

.message-header {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 0.5rem;
    font-size: 0.875rem;
    color: #666;
}

.message-content {
    color: #333;
    line-height: 1.5;
    white-space: pre-wrap;
}

.message-content :deep(code) {
    background-color: #f5f5f5;
    padding: 2px 6px;
    border-radius: 4px;
    font-family: 'Courier New', monospace;
}

.message-content :deep(pre) {
    background-color: #f5f5f5;
    padding: 1rem;
    border-radius: 4px;
    overflow-x: auto;
    margin: 0.5rem 0;
}
.message-content :deep(ul),
.message-content :deep(ol){
    display: flex;
    flex-direction: column;
    gap: 0

}

.allegati-selection-section {
    /*background-color: #f8f9fa;
    border-radius: 8px;
    padding: 0.75rem;
    border: 1px solid #e0e0e0;*/
    display: flex;
    flex-direction: column;
    height: 100%;
}

.allegati-selection-header {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 0.5rem;
    font-size: 0.75rem;
    color: #333;
    font-weight: 600;
}

.allegati-selection-header strong {
    font-size: 0.75rem;
}

.selected-count {
    color: #0066cc;
    font-weight: 500;
    font-size: 0.7rem;
}

.allegati-selection-list {
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
    overflow-y: auto;
    flex: 1;
}

.allegato-checkbox-item {
    display: flex;
    align-items: flex-start;
    gap: 0.4rem;
    background-color: white;
    padding: 0.4rem;
    border-radius: 4px;
    border: 1px solid #d0d0d0;
    transition: background-color 0.2s;
}

.allegato-checkbox-item:hover {
    background-color: #f5f5f5;
}

.allegato-checkbox {
    cursor: pointer;
    width: 14px;
    height: 14px;
    margin-top: 2px;
    flex-shrink: 0;
}

.allegato-label {
    display: flex;
    align-items: flex-start;
    gap: 0.3rem;
    cursor: pointer;
    font-size: 0.75rem;
    flex: 1;
    min-width: 0;
}

.allegato-label i {
    color: #666;
    font-size: 0.7rem;
    margin-top: 2px;
    flex-shrink: 0;
}

.allegato-label span {
    color: #333;
    word-break: break-word;
    line-height: 1.3;
}

.upload-area {
    flex: 1;
    display: flex;
    flex-direction: column;
}

.uploaded-files-list {
    display: flex;
    
    gap: 0.4rem;
    overflow-y: auto;
    flex: 1;
}

.uploaded-file-item {
    display: flex;
    align-items: center;
    gap: 0.4rem;
    background-color: white;
    padding: 0.4rem;
    border-radius: 4px;
    
    font-size: 0.75rem;
}

.uploaded-file-item i.pi-file {
    color: #666;
    font-size: 0.7rem;
    flex-shrink: 0;
}

.uploaded-file-item span {
    flex: 1;
    color: #333;
    word-break: break-word;
    line-height: 1.3;
}

.uploaded-file-item i.pi-times {
    color: #e74c3c;
    font-size: 0.7rem;
    flex-shrink: 0;
}

.uploaded-file-item i.pi-times:hover {
    color: #c0392b;
}

</style>

<script>
import DOMPurify from 'dompurify';
import Button from 'primevue/button';
import Dialog from 'primevue/dialog';
import Textarea from 'primevue/textarea';
import Select from 'primevue/select';

export default {
    name: 'AiAssistant',
    components: {
        Button,
        Dialog,
        Textarea,
        Select
    },
    props: {
        ticketMessage: {
            type: String,
            required: true
        },
        available_ai_models: {
            type: Array,
            default: () => []
        },
        ruolo: {
            type: String,
            required: true
        },
        allegati: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            visible: false,
            inputMessage: '',
            messages: [],
            ai_models : [],
            loading: false,
            selectedModel: 'gemini',
            selectedAllegati: [],
            uploadedFiles: [],
            nomeUtente: ''
        };
    },
    computed: {
        selectedModelLabel() {
            const model = this.ai_models.find(m => m.value === this.selectedModel);
            return model ? model.label : 'AI';
        }
    },
    mounted() {
        console.log(this.available_ai_models);
        axios.get('/menu_utente').then(response => {
            const data = response.data;
            this.nomeUtente = data.nome;
        });
        this.ai_models = JSON.parse(this.available_ai_models);
        console.log(this.ai_models);
        const modelLabels = {
                'gemini': 'Google Gemini',
                'openai': 'ChatGPT (OpenAI)',
                'claude': 'Claude (Anthropic)',
                'copilot': 'Microsoft Copilot'
        };
         this.ai_models = this.ai_models.map(modelValue => ({
            label: modelLabels[modelValue] || modelValue,
            value: modelValue
        }));
        // Imposta il primo modello disponibile come default
        if (this.ai_models.length > 0 && !this.selectedModel) {
            
            this.selectedModel = this.ai_models[0].value;
        }
    },
    methods: {
        openModal() {
            this.visible = true;
            // Imposta il messaggio del ticket come primo messaggio
            if (this.messages.length === 0) {
                this.inputMessage = this.ticketMessage.replace(/(<([^>]+)>)/gi, "");
            }
        },
        async sendMessage() {
            if (!this.inputMessage.trim() || this.loading) return;

            // Aggiungi il messaggio dell'utente
            this.messages.push({
                role: 'user',
                content: this.inputMessage
            });

            const userMessage = this.inputMessage;
            this.inputMessage = '';
            this.loading = true;

            // Scroll to bottom
            this.$nextTick(() => {
                this.scrollToBottom();
            });

            try {
                const response = await this.callAiApi(userMessage);
                
                // Aggiungi la risposta dell'assistente
                this.messages.push({
                    role: 'assistant',
                    content: response
                });
            } catch (error) {
                console.error('Errore chiamata API:', error);
                this.$toast.add({
                    severity: 'error', 
                    summary: 'Errore', 
                    detail: this.$root.trans.impossibile_ottenere_risposta,
                    life: 5000
                });
                
                this.messages.push({
                    role: 'assistant',
                    content: this.$root.trans.errore_ai
                });
                
            } 
            this.loading = false;
            this.$nextTick(() => {
                this.scrollToBottom();
            });
        },
        handleFileUpload(event) {
            const files = Array.from(event.target.files);
            files.forEach(file => {
                // Verifica dimensione file (max 10MB)
                if (file.size > 10 * 1024 * 1024) {
                    this.$toast.add({
                        severity: 'warn',
                        summary: 'File troppo grande',
                        detail: `${file.name} supera i 10MB`,
                        life: 3000
                    });
                    return;
                }
                this.uploadedFiles.push(file);
            });
            // Reset input
            event.target.value = '';
        },
        removeUploadedFile(index) {
            this.uploadedFiles.splice(index, 1);
        },
        async convertFileToBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => {
                    const base64 = reader.result.split(',')[1];
                    resolve(base64);
                };
                reader.onerror = reject;
                reader.readAsDataURL(file);
            });
        },
        async callAiApi(message) {
            // Prepara il contesto della conversazione
            const conversationHistory = this.messages.map(m => ({
                role: m.role,
                content: m.content
            }));

            // Prepara allegati esistenti selezionati
            const allegatiEsistenti = this.selectedAllegati.map(a => ({
                id: a.id,
                nome: a.nome,
                url: a.url,
                tipo: a.tipo || a.tabella
            }));

            // Prepara file caricati
            const allegatiCaricati = [];
            for (const file of this.uploadedFiles) {
                const base64Content = await this.convertFileToBase64(file);
                allegatiCaricati.push({
                    nome: file.name,
                    content: base64Content,
                    tipo: 'uploaded',
                    mime_type: file.type,
                    size: file.size
                });
            }

            const data = {
                model: this.selectedModel,
                message: message,
                history: conversationHistory,
                allegati: [...allegatiEsistenti, ...allegatiCaricati]
            };

            // Costruisci l'URL basato sul ruolo
            const apiUrl = `/${this.ruolo}/ticketing/ai-assistant`;

            // Chiamata al backend Laravel che gestirà le API dei vari provider
            const response = await axios.post(apiUrl, data);
            
            return response.data.response;
        },
        formatMessage(content) {
            // Formattazione base del messaggio (markdown-like)
            let formatted = content
                .replace(/```(\w+)?\n([\s\S]*?)```/g, '<pre><code>$2</code></pre>')
                .replace(/`([^`]+)`/g, '<code>$1</code>')
                .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
                .replace(/\*(.+?)\*/g, '<em>$1q</em>');
            
            return DOMPurify.sanitize(formatted, { ALLOWED_TAGS: ['pre', 'code', 'strong', 'em'] });
        },
        scrollToBottom() {
            const container = this.$refs.chatMessages;
            if (container) {
                container.scrollTop = container.scrollHeight;
            }
        }
    }
};
</script>
